import React from 'react';
import { View, StyleSheet } from 'react-native';

export default function SunIllustration({ size }) {
  var s = size || 70;
  var sunR = s * 0.2;
  var cloudW = s * 0.7;

  return (
    <View style={[styles.wrap, { width: s, height: s * 0.8 }]}>
      {/* Sun circle */}
      <View style={[styles.sunBack, {
        width: sunR * 2.2,
        height: sunR * 2.2,
        borderRadius: sunR * 1.1,
        top: s * 0.12,
        right: s * 0.1,
      }]} />
      <View style={[styles.sunFront, {
        width: sunR * 1.8,
        height: sunR * 1.8,
        borderRadius: sunR * 0.9,
        top: s * 0.16,
        right: s * 0.18,
      }]} />
      {/* Cloud */}
      <View style={[styles.cloudMain, {
        width: cloudW,
        height: s * 0.28,
        borderRadius: s * 0.14,
        bottom: s * 0.05,
        left: (s - cloudW) / 2,
      }]} />
      <View style={[styles.cloudLeft, {
        width: s * 0.36,
        height: s * 0.22,
        borderRadius: s * 0.11,
        bottom: s * 0.08,
        left: s * 0.1,
      }]} />
    </View>
  );
}

var styles = StyleSheet.create({
  wrap: { position: 'relative' },
  sunBack: { position: 'absolute', backgroundColor: '#E8B84A', opacity: 0.9 },
  sunFront: { position: 'absolute', backgroundColor: '#F0CC60' },
  cloudMain: { position: 'absolute', backgroundColor: 'rgba(255,255,255,0.85)' },
  cloudLeft: { position: 'absolute', backgroundColor: 'rgba(255,255,255,0.7)' },
});
